import UserReturnAcknowledgementDesktop from "../components/desktop/user-return-acknowledgement/UserReturnAcknowledgementDesktop";

const UserReturnAcknowledgement = () => {
  return (
    <>
      <UserReturnAcknowledgementDesktop />
    </>
  );
};

export default UserReturnAcknowledgement;
